import { Component, Input } from '@angular/core';
import { DsButtonVariants, DsModalService, DsModalVariant, Icons, IconStyles } from '@levelaccess/design-system';
import { ShareIssueReportModalComponent } from '../share-issue-report-modal/share-issue-report-modal.component';

export type UrlFactory = string | (() => Promise<string>);

@Component({
  selector: 'app-share-issue-report-url',
  templateUrl: './share-issue-report-url.component.html',
  styleUrls: ['./share-issue-report-url.component.scss'],
  standalone: false,
})
export class ShareIssueReportUrlComponent {
  @Input() public url: UrlFactory;

  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly Icons: typeof Icons = Icons;
  protected readonly IconStyles: typeof IconStyles = IconStyles;

  constructor(private dsModalService: DsModalService) {}

  public async openShareIssueModal(): Promise<void> {
    let issueLink: string;
    switch (typeof this.url) {
      case 'string':
        issueLink = this.url;
        break;
      case 'function':
        issueLink = await this.url().catch(() => window.location.href);
        break;
      default:
        issueLink = window.location.href;
        break;
    }

    const modalInstance: ShareIssueReportModalComponent = this.dsModalService.open(
      ShareIssueReportModalComponent,
      DsModalVariant.center,
    ).componentInstance;

    modalInstance.modalInputData = {
      data: {
        url: issueLink,
      },
    };
  }
}
